

export class State {
    date!: Date;
    comment!: string;
    ok!:boolean;
    status!: number;
}
